<template>
  <div class="success-page">
    <div class="center-screen">
      <img
        src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
        alt="Check icon"
        class="centered-icon"
      />
    </div>

    <h2><b>Fast fertig</b></h2>
    <br />
    <p class="description">
      Vielen Dank für den erfolgreichen Abschluss. So geht's jetzt weiter –
      Schritt für Schritt:
    </p>

    <div class="icon-section">
      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path
              fill="#f9b218"
              d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
            />
          </svg>
        </div>
        <h3>Postboten -Identifikation</h3>
        <p>
          In den nächsten Tagen besucht Sie ein Postbote der Österreichischen
          Post AG zur einfachen Identifizierung – ganz bequem bei Ihnen zu
          Hause.
        </p>
      </div>

      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path
              fill="#f9b218"
              d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
            />
          </svg>
        </div>
        <h3>Antragserhalt</h3>
        <p>
          Der Postbote übernimmt die Identifikation vor Ort und übergibt Ihnen
          Ihren Termingeldantrag persönlich.
        </p>
      </div>

      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path
              fill="#f9b218"
              d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l293.1 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1l-91.4 0zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
            />
          </svg>
        </div>
        <h3>Antrag prüfen & retournieren</h3>
        <p>
          Verschaffen Sie sich einen kurzen Überblick über Ihren Antrag und
          kontrollieren Sie die Angaben. Wenn alles stimmt, unterschreiben Sie
          bitte und senden ihn im beigelegten Rückumschlag kostenlos zurück.
        </p>
      </div>

      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
            <path
              fill="#f9b218"
              d="M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
            />
          </svg>
        </div>
        <h3>IBAN-Erhalt & Einzahlung</h3>
        <p>
          Ihre persönliche IBAN erhalten Sie von uns in der Regel innerhalb von
          1–2 Bankwerktagen. Damit ist alles bereit für Ihre Einzahlung – und
          Ihre Veranlagung kann starten.
        </p>
      </div>
    </div>

    <button @click="goHome" class="home-button">Zurück zur Startseite</button>
    <section v-if="pdfLocation" class="flex justify-center flex-col my-4">
      <div class="max-w-md mx-auto text-center">
        <p>
          Hier können Sie
          <a :href="pdfLocation" target="_blank" class="underline" download>
            das PDF herunterladen
          </a>
          <br />
          Bitte schließen Sie die Identifikation ab, um den Prozess
          abzuschließen.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      guid: "",
      pdfLocation: "", // Make sure this is here
      validGuid: false,
      loading: false,
      showModal: false,
      isGemeinschaftskonto: false,
      showErrorMessage: false,
    };
  },

  mounted() {
    // Access `guid` from route params
    this.guid = this.$route.params.guid;
    console.log("GUID from URL:", this.guid); // Ensure the GUID is correctly extracted

    this.loadStepFiveInfo();
  },

  methods: {
    async loadStepFiveInfo() {
      this.loading = true;

      // Ensure `guid` is present
      if (!this.guid) {
        console.error("Error: Missing GUID (Processid)!");
        this.loading = false;
        return; // Exit if no GUID
      }

      try {
        const res = await axios.get(
          process.env.VUE_APP_BACKEND_DOMAIN + "create-account.php?step=5",
          {
            headers: {
              Processid: this.guid, // Send GUID in the request header
            },
          }
        );

        // Handle the response data
        console.log("Response data:", res.data);
        this.pdfLocation =
          process.env.VUE_APP_BACKEND_DOMAIN + res.data.pdfLocation;
        this.loading = false;
        this.validGuid = true;
      } catch (error) {
        console.error("Error loading step 5 data:", error);
        this.validGuid = false;
        this.loading = false;
      }
    },

    goHome() {
      const locale = this.$route.params.locale || "en";
      this.$router.push({ name: "choosemode", params: { locale } });
    },
  },
};
</script>

<style scoped>
.success-page {
  text-align: center;
  padding: 30px;
  max-width: 1000px;
  margin: auto;
  font-family: Arial, sans-serif;
}

.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.centered-icon {
  width: 80px;
}

.description {
  font-size: 18px;
  margin-bottom: 30px;
}
.icon-circle svg {
  width: 50px;
  height: 50px;
  display: block;
}

.icon-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 60px;
  margin-bottom: 30px;
}
p {
  color: #7a7a7a;
}
.icon-item {
  text-align: center;
  flex: 1 1 200px;
  max-width: 290px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
}

.icon-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 6px solid #f9b218;
  border-radius: 50%;
  padding: 15px;
  width: 100px;
  height: 100px;
  margin-bottom: 15px;
}

.icon-item h3 {
  color: #f9b218;
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 18px;
}

.icon-item p {
  font-size: 14px;
  color: #7a7a7a;
}

.home-button {
  margin: 30px;
  background-color: #ffb300a1;
  color: rgb(0, 0, 0);
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.home-button:hover {
  background-color: #e78e07;
}

.download-note {
  font-size: 14px;
  color: #333;
}

.download-note a {
  color: #007bff;
  text-decoration: none;
}

.download-note a:hover {
  text-decoration: underline;
}
</style>
